__turbopack_context__.v({
  "container": "StripeAddressElement-module__2YS8rW__container",
});
